import { AsyncPipe, DecimalPipe, NgForOf, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UserCompany } from '@company/const';
import { CompanyService } from '@company/feature';
import { SdAddCompanyButtonModule } from '@sdvor/company/ui';
import { DropdownComponent, DropdownMenuComponent, DropdownMenuItemComponent } from '@sdvor/shared/ui/v2';
import { Observable } from 'rxjs';

@Component({
  selector: 'sd-user-companies',
  templateUrl: './user-companies.component.html',
  styleUrls: ['./user-companies.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgForOf,
    DropdownComponent,
    DropdownMenuItemComponent,
    DropdownMenuComponent,
    AsyncPipe,
    SdAddCompanyButtonModule,
    NgIf,
    DecimalPipe,
  ],
})
export class UserCompaniesComponent implements OnInit {
  companies$: Observable<UserCompany[]>;
  isRemoveInProgress$: Observable<boolean>;

  constructor(private companyService: CompanyService) {}

  ngOnInit(): void {
    this.companies$ = this.companyService.getUserCompanies();
    this.isRemoveInProgress$ = this.companyService.getRemoveCompanyLoading();
  }

  remove(uid: string): void {
    this.companyService.removeCompany(uid);
  }

  select(uid: string): void {
    this.companyService.selectCompany(uid);
  }
}
